import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useRef, useState } from "react";
import "animate.css";
import {
  Add,
  ArrowBack,
  ArrowForward,
  Close,
  Delete,
  Mail,
  Phone,
} from "@mui/icons-material";
import { allowOnlyNumbers } from "../../utils/inputUtils";
const LeadCapture = () => {
  const theme = useTheme();
  const nameRef = useRef();
  const selfRef = useRef();
  const ageRef = useRef();
  const spouseRef = useRef();
  const personalInfoRef = useRef();
  const [step, setStep] = useState(0);
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [forSpouse, setForSpouse] = useState();
  const [spouseDob, setSpouseDob] = useState();
  const [child, setChild] = useState([]);
  const [selfGender, setSelfGender] = useState("");
  const addChild = () => {
    setChild((prev) => [...prev, { name: "", dob: "" }]);
  };
  const removeChild = (index) => {
    setChild((prev) => prev.filter((_, i) => i !== index));
  };
  const clearClassesFromAllRef = () => {
    nameRef.current.classList.remove(
      "animate__animated",
      "animate__slideOutLeft",
      "animate__slideInRight"
    );
    selfRef.current.classList.remove(
      "animate__animated",
      "animate__slideOutLeft",
      "animate__slideInRight"
    );
    ageRef.current.classList.remove(
      "animate__animated",
      "animate__slideOutLeft",
      "animate__slideInRight"
    );
    personalInfoRef.current.classList.remove(
      "animate__animated",
      "animate__slideOutLeft",
      "animate__slideInRight"
    );
  };
  const handleNext = () => {
    clearClassesFromAllRef();
    if (step === 0) {
      setStep(1);

      nameRef.current.style.display = "none";
      selfRef.current.style.display = "block";
      selfRef.current.classList.add(
        "animate__animated",
        "animate__slideInRight"
      );
    } else if (step === 1) {
      setStep(2);
      selfRef.current.style.display = "none";
      ageRef.current.style.display = "block";
      ageRef.current.classList.add(
        "animate__animated",
        "animate__slideInRight"
      );
    } else if (step === 2) {
      setStep(3);
      ageRef.current.style.display = "none";
      personalInfoRef.current.style.display = "block";
      personalInfoRef.current.classList.add(
        "animate__animated",
        "animate__slideInRight"
      );
    }
  };
  const handleBack = () => {
    clearClassesFromAllRef();
    if (step === 1) {
      setStep(0);
      nameRef.current.style.display = "block";
      nameRef.current.classList.add(
        "animate__animated",
        "animate__slideInLeft"
      );
      selfRef.current.style.display = "none";
    } else if (step === 2) {
      setStep(1);
      selfRef.current.style.display = "block";
      selfRef.current.classList.add(
        "animate__animated",
        "animate__slideInLeft"
      );
      ageRef.current.style.display = "none";
    } else if (step === 3) {
      setStep(2);
      ageRef.current.style.display = "block";
      ageRef.current.classList.add("animate__animated", "animate__slideInLeft");
      personalInfoRef.current.style.display = "none";
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        background: theme.palette.primary.main,
        p: 1,
      }}
    >
      <Paper
        sx={{
          minHeight: "400px",
        }}
      >
        <Typography variant='h5' align='center' color='primary.main'>
          Cashless Mediclaim Policy
        </Typography>
        <Typography variant='h6' align='center' color='text.secondary'>
          Get a Free Quote
        </Typography>
        <Box
          px={1}
          mt={2}
          sx={{
            overflow: "hidden",
            "& > div": {
              width: "100%",
              margin: "0 auto",
            },
          }}
        >
          <div ref={nameRef}>
            <Grid container spacing={2}>
              <SectionHeading
                handleBack={handleBack}
                title={`
              Hi, I am your personal assistant. Please tell me your name.
              `}
              />
              <Grid item xs={12}>
                <Box px={2} mb={2}>
                  <TextField
                    placeholder='Your Full Name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                  ></TextField>
                </Box>
              </Grid>
              <SectionFooter handleNext={handleNext} />
            </Grid>
          </div>
          <div
            ref={selfRef}
            style={{
              display: "none",
            }}
          >
            <Grid container spacing={2}>
              <SectionHeading
                handleBack={handleBack}
                title={`Hi ${name}, Please provide your Gender & Date of Birth.
              `}
              />
              <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                <div className='radio-container'>
                  <input
                    type='radio'
                    id='Self_Male'
                    name='gender'
                    value={"male"}
                    checked={selfGender === "male"}
                    onChange={(e) => {
                      setSelfGender(e.target.value);
                    }}
                  />
                  <label htmlFor='Self_Male'>Male</label>
                  <input
                    type='radio'
                    id='Self_Female'
                    name='SelfGender'
                    value={"female"}
                    checked={selfGender === "female"}
                    onChange={(e) => {
                      setSelfGender(e.target.value);
                    }}
                  />
                  <label htmlFor='Self_Female'>Female</label>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                display={"flex"}
                justifyContent={"center"}
                mb={2}
              >
                {" "}
                <TextField
                  type='date'
                  placeholder='Your Date of Birth'
                  fullWidth
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                />
              </Grid>
              <SectionFooter handleNext={handleNext} />
            </Grid>
          </div>
          <div
            ref={ageRef}
            style={{
              display: "none",
            }}
          >
            <Grid container spacing={2}>
              <SectionHeading
                title={`Thanks ${name}, Do you need a cover for your spouse or children?`}
                handleBack={handleBack}
              />
              <Grid display={"flex"} justifyContent={"center"} item xs={12}>
                <div className='radio-container'>
                  <input
                    type='radio'
                    id='Yes'
                    name='forSpouse'
                    value={"Y"}
                    checked={forSpouse === "Y"}
                    onChange={(e) => {
                      setForSpouse(e.target.value);
                      spouseRef.current.style.display = "block";
                      spouseRef.current.classList.add(
                        "animate__animated",
                        "animate__slideInRight"
                      );
                    }}
                  />
                  <label htmlFor='Yes'>Yes</label>
                  <input
                    type='radio'
                    id='No'
                    name='forSpouse'
                    value={"N"}
                    checked={forSpouse === "N"}
                    onChange={(e) => {
                      setForSpouse(e.target.value);
                      spouseRef.current.style.display = "none";
                      spouseRef.current.classList.remove(
                        "animate__animated",
                        "animate__slideInRight"
                      );
                      handleNext();
                    }}
                  />
                  <label htmlFor='No'>No</label>
                </div>
              </Grid>
            </Grid>
            <div
              ref={spouseRef}
              style={{
                display: "none",
                width: "100%",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack spacing={2} width={"100%"}>
                    <Typography
                      mt={2}
                      variant='body1'
                      color='text.secondary'
                      align='center'
                    >
                      Please provide your spouse's DOB.
                    </Typography>
                    <TextField
                      type='date'
                      placeholder='Your Spouse Date of Birth'
                      value={spouseDob}
                      fullWidth
                      onChange={(e) => setSpouseDob(e.target.value)}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Box px={2} mb={2} display={"flex"} justifyContent={"right"}>
                    <Button
                      variant='contained'
                      startIcon={<Add />}
                      onClick={addChild}
                    >
                      Add Children
                    </Button>
                  </Box>
                </Grid>
                {child.map((item, index) => {
                  return (
                    <>
                      <Grid item xs={12}>
                        <Stack
                          spacing={2}
                          width={"100%"}
                          justifyContent={"center"}
                          aignItems={"center"}
                          position={"relative"}
                        >
                          <IconButton
                            sx={{
                              position: "absolute",
                              top: "8px",
                              right: "-12px",
                            }}
                            onClick={() => removeChild(index)}
                          >
                            <Delete />
                          </IconButton>

                          <Typography
                            variant='body1'
                            color='text.secondary'
                            align='center'
                          >
                            Please provide your child {index + 1} DOB & Gender.
                          </Typography>
                          <div className='radio-container center'>
                            <input
                              type='radio'
                              id={`Male${index}`}
                              name={`gender${index}`}
                              value={"male"}
                              checked={item.gender === "male"}
                              onChange={(e) => {
                                const temp = [...child];
                                setChild(
                                  temp.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        gender: e.target.value,
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                            />
                            <label htmlFor={`Male${index}`}>Male</label>
                            <input
                              type='radio'
                              id={`Female${index}`}
                              name={`gender${index}`}
                              value={"female"}
                              checked={item.gender === "female"}
                              onChange={(e) => {
                                const temp = [...child];
                                setChild(
                                  temp.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        gender: e.target.value,
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                            />
                            <label htmlFor={`Female${index}`}>Female</label>
                          </div>
                          <TextField
                            type='date'
                            placeholder='Your Child Date of Birth'
                            fullWidth
                            value={item.dob}
                            onChange={(e) => {
                              const temp = [...child];
                              setChild(
                                temp.map((item, i) => {
                                  if (i === index) {
                                    return {
                                      ...item,
                                      dob: e.target.value,
                                    };
                                  }
                                  return item;
                                })
                              );
                            }}
                          />
                        </Stack>
                      </Grid>
                    </>
                  );
                })}
                <SectionFooter handleNext={handleNext} />
              </Grid>
            </div>
          </div>
          <div
            ref={personalInfoRef}
            style={{
              display: "none",
            }}
          >
            <Grid container spacing={2}>
              <SectionHeading
                title={`Thanks ${name}, Please provide your personal information.`}
                handleBack={handleBack}
              />
              <Grid item xs={12}>
                <TextField
                  type='tel'
                  placeholder='Your Phone Number'
                  fullWidth
                  onInput={allowOnlyNumbers}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Phone />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  type='email'
                  placeholder='Your Email'
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Mail />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box px={2} mb={2} display={"flex"} justifyContent={"right"}>
                  <Button variant='contained'>Submit</Button>
                </Box>
              </Grid>
            </Grid>
          </div>
        </Box>
      </Paper>
    </Box>
  );
};

export default LeadCapture;

const SectionHeading = ({ title, handleBack }) => {
  return (
    <>
      <Grid item xs={2}>
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
      </Grid>
      <Grid item xs={10}>
        <Typography variant='body1' color='text.secondary'>
          {title}
        </Typography>
      </Grid>
    </>
  );
};

const SectionFooter = ({ handleNext }) => {
  return (
    <Grid item xs={12}>
      <Box px={2} mb={2} display={"flex"} justifyContent={"right"}>
        <Button
          variant='contained'
          endIcon={<ArrowForward />}
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Grid>
  );
};
